import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const HeartGlassIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="43"
			height="47"
			viewBox="0 0 43 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g opacity="0.5">
				<path
					d="M37.7936 37.0665C35.1309 33.9018 32.6482 30.5832 29.8922 27.4954C36.4987 17.7165 33.4818 3.08951 20.8931 0.469537C5.19747 -2.79581 -5.46068 11.5531 2.96097 25.4357C5.77664 30.0761 11.1789 32.9824 16.5485 33.4437C19.7969 33.7226 22.35 32.3002 25.3293 31.3628C29.5462 35.7348 33.3664 40.4725 37.2202 45.1653C38.4137 46.3006 40.6608 46.7709 41.9124 45.5154C42.2822 45.144 42.6389 44.227 42.6282 43.697C42.5857 41.6259 39.1516 38.6804 37.7936 37.0665ZM20.9871 32.0351C14.1377 34.031 6.38606 30.1317 3.1082 23.9797C-2.71538 13.0524 3.4526 1.10755 16.0855 0.791814C28.6472 0.47853 35.1498 11.2897 31.3803 22.7953C29.6182 28.1743 26.2463 30.5023 20.9871 32.0351ZM37.7969 44.5886C36.5355 43.4402 34.9215 40.9371 33.7084 39.5147C31.3034 36.6943 28.8648 33.8911 26.3436 31.173L26.2815 30.7027C27.3424 30.1186 28.5507 29.3898 29.1937 28.3338L29.5307 28.2307C29.5503 28.3706 29.5953 28.5326 29.6935 28.6348C32.5967 31.6605 35.1555 35.2416 37.882 38.4497C38.8096 39.5417 40.6494 41.1016 41.285 42.2459C42.8932 45.1415 39.8354 46.4446 37.7969 44.5886Z"
					fill="currentColor"
				/>
				<path
					d="M15.1039 3.73826C4.02856 4.78036 0.542924 16.2238 6.88759 24.6162C9.67381 28.3012 15.5947 30.5555 20.0808 29.3277C24.7837 28.0411 27.4791 26.0288 28.833 21.2298C31.665 11.1941 25.8512 2.72806 15.1039 3.73826ZM28.2767 20.0192C27.2484 24.6121 25.4913 26.5385 21.1107 28.0681C4.8556 33.744 -3.11369 6.2658 15.1039 4.55623C24.7469 3.65237 30.3504 10.7605 28.2767 20.0192Z"
					fill="currentColor"
				/>
				<path
					d="M17.5923 13.3429C17.6733 10.013 15.71 8.38847 12.4363 8.76146C9.60014 9.08456 9.20748 12.4522 9.40462 14.7392C9.54696 16.3899 10.3797 18.106 11.1249 19.5628C12.0289 21.3313 13.1635 23.0212 14.0985 24.7782C18.3187 23.6715 25.2859 19.5113 25.245 14.5699C25.2058 9.73322 19.9163 10.6763 17.5923 13.3429ZM14.4167 23.8253C12.6383 19.9374 9.19847 16.2975 10.4411 11.6735C10.6996 10.7099 11.4023 9.7463 12.4518 9.59497C14.0052 9.37085 15.9546 9.76185 16.4978 11.4084C16.5452 11.5524 16.7726 12.5389 16.7726 12.6068V15.1425C17.7289 15.2995 17.9817 14.138 18.5658 13.5818C20.2174 12.0096 23.9877 10.7172 24.3059 14.0701C24.7657 18.9084 18.3138 22.5345 14.4167 23.8253Z"
					fill="currentColor"
				/>
				<path
					d="M21.2743 17.9234C20.4276 17.741 21.9909 15.9553 22.1013 15.4809C22.2404 14.883 22.1496 14.272 22.1725 13.6699L22.9103 13.8311C23.6801 14.8642 21.9606 18.0706 21.2743 17.9234Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
};

export default memo(HeartGlassIcon);
